import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { StateModel } from '../../../../models/state.model';
import { StateService } from '../../../../services/state.service';
import { CityService } from '../../../../services/city.service';
import { NgForOf, NgIf } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';


@Component({
    standalone: true,
    imports: [ReactiveFormsModule, FormsModule, NgIf, NgForOf,MatTableModule,MatPaginatorModule, RouterModule],
    providers: [StateService, CityService],
    selector: 'state-index',
    templateUrl: './state-index.component.html',
    styleUrls: ['./state-index.component.css']
})
export class StateIndexComponent implements AfterViewInit , OnInit {
    filter: string;
    allStates: StateModel[];
    states: StateModel[];
    displayedColumns: string[] = ['לענדער', 'state', 'actions'];
    dataSource = new MatTableDataSource<StateModel>();
    @ViewChild(MatPaginator) paginator: MatPaginator;

    constructor(private stateService: StateService, private cityService: CityService) { }


    ngOnInit(): void {
    
        this.stateService.getStates().subscribe(s => {
            this.states = this.allStates = s;
            this.dataSource.data = this.states
        });
       this.onSearch()
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
      }
    onDelete(id: number) {

        this.cityService.getCityStateId(id).subscribe(c => {

            if (c.length) {

                alert("Can't delete state with city attached");
                return;
            }
            if (confirm("Are you sure?")) {
                this.stateService.delete(id).subscribe(s => {
                    var i = this.states.findIndex(function (s) {
                        return s.id == id;
                    });

                    this.states.splice(i, 1);
                });
            }
        });
    }

    compare(a: string, b: string) {
        const genreA = a.toUpperCase();
        const genreB = b.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
            comparison = 1;
        } else if (genreA < genreB) {
            comparison = -1;
        }
        return comparison;
    }
    onSearch() {
        var states = this.allStates;

        if (this.filter) { 
            states = states.filter(s => s.stateY.includes(this.filter)
                || s.stateE.includes(this.filter)
                || s.stateE.toLowerCase().includes(this.filter)
                || s.stateE.toUpperCase().includes(this.filter));
        }

        this.dataSource.data = states;
    }
}

